import StockTransactionDelete from './StockTransactionDelete'
export {StockTransactionDelete}
export default StockTransactionDelete
